import { Navigate, Route, Routes } from "react-router-dom";
import GameEnd from "./components/GameEnd/GameEnd";
import Avatar from "./pages/Avatar/Avatar";
import BlendingGame from "./pages/BlendingGame/BlendingGame";
import Dashboard from "./pages/Dashboard/Dashboard";
import LevelSelect from "./pages/LevelSelect/LevelSelect";
import Login from "./pages/Login/Login";
import Registration from "./pages/Registration/Registration";
import StatsPage from "./pages/StatsPage/StatsPage";
import StoryContainer from "./pages/StoryContainer/StoryContainer";
import SwingGame from "./pages/SwingGame/SwingGame";
import SwingGameInstructions from "./pages/SwingGameInstructions/SwingGameInstructions";
import BlendingGameInstructions from "./pages/BlendingGameInstructions/BlendingGameInstructions";

import "./styles/main.scss";

const App = () => (
  <Routes>
    {/* PUBLIC ROUTES */}
    <Route path="/login" element={<Login />} />
    <Route path="/registration" element={<Registration isAdmin={false} />} />
    <Route
      path="/registration-admin"
      element={<Registration isAdmin={true} />}
    />

    {/* PROTECTED ROUTES */}
    <Route path="/dashboard" element={<Dashboard />} />
    <Route path="/swing-game" element={<LevelSelect gameName="Swing" />} />
    <Route path="/swing-game/play/:level" element={<SwingGame />} />
    <Route
      path="/blending-game"
      element={<LevelSelect gameName="Blending" />}
    />
    <Route path="/blending-game/play/:level" element={<BlendingGame />} />
    <Route path="/story-container" element={<StoryContainer />} />
    <Route path="/stats-page" element={<StatsPage />} />
    <Route path="/avatar-page" element={<Avatar />} />

    {/* UNIMPLEMENTED ROUTES */}
    <Route
      path="/swing-game-instructions"
      element={<SwingGameInstructions />}
    />
    <Route
      path="/blending-game-instructions"
      element={<BlendingGameInstructions />}
    />
    <Route path="/end-game" element={<GameEnd />} />

    {/* REDIRECTS */}
    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);

export default App;
